import gql from 'graphql-tag'
import client from '../../stores/apollo'

interface Payload {
  data: {
    viewer: {
      company: {
        projection_cities: string[]
      }
    }
  }
}

export default function list(includeOldBuildings?: boolean): Promise<string[]> {
  return client.gql.query({ query, variables: { includeOldBuildings } }).then(
    ({
      data: {
        viewer: {
          company: { projection_cities },
        },
      },
    }: Payload) => projection_cities
  )
}

export const query = gql`
  query cities($includeOldBuildings: Boolean) {
    viewer {
      company {
        projection_cities(includeOldBuildings: $includeOldBuildings)
      }
    }
  }
`
